import Title_ru_RU_Class from "@/core/misc/decorators/Title_ru_RU_Class";

import Core              from "@/core/Core";
import DateSimple        from "@/core/types/DateSimple";
import Sum               from "@/core/types/Sum";
import CurrencyRate      from "@/core/types/CurrencyRate";
import Multiplier        from "@/core/types/Multiplier";

/**
 * Строка реестра «Сверка документов»: отгрузка (документ поставщика) рядом с реализацией
 * и тем, что ушло в Техно. Только для чтения, статус сверки меняется через ShipmentsService.setIsVerified
 */
@Title_ru_RU_Class('Сверка документов')
class ShipmentReconciliation {
  public id: number;

  public documentType: string;
  public documentNumber: string;
  public documentDate: DateSimple;
  public shipmentDate: DateSimple;

  public sellerId: number;
  public sellerName: string | null;
  public sellerCompanyName: string | null;

  public orderCurrencyCode: string;
  public sumFull: Sum;
  public accountingCurrencyCode: string;
  public accountingCurrencyRate: CurrencyRate | null;
  /** Ручная с бумажного документа приоритетнее расчётной */
  public accountingSumFull: Sum | null;
  /** Дооценка, входит в accountingSumFull */
  public accountingServiceSumFull: Sum | null;

  public isVerified: boolean;
  public externalNumber: string | null;

  public shipmentToBuyerId: number | null;
  public shipmentToBuyerDate: DateSimple | null;
  public shipmentToBuyerAccountingSumFull: Sum | null;

  public tehnoShipmentId: number | null;
  /** Что мы отправили в Техно: документ поставщика с дооценкой */
  public tehnoShipmentSumFull: Sum | null;
  /** Сумма строк фактуры в Техно, перечитывается кроном */
  public tehnoSumFull: Sum | null;
  public tehnoStage: number | null;

  static fromServer(data: any, result = new ShipmentReconciliation()): ShipmentReconciliation {
    Object.assign(result, data);

    result.documentDate                     = Core.utils.hydrate(data.documentDate, DateSimple.fromServer)!;
    result.shipmentDate                     = Core.utils.hydrate(data.shipmentDate, DateSimple.fromServer)!;
    result.sumFull                          = Core.utils.hydrate(data.sumFull, Sum.fromServer)!;
    result.accountingCurrencyRate           = Core.utils.hydrate(data.accountingCurrencyRate, CurrencyRate.fromServer);
    result.accountingSumFull                = Core.utils.hydrate(data.accountingSumFull, Sum.fromServer);
    result.accountingServiceSumFull         = Core.utils.hydrate(data.accountingServiceSumFull, Sum.fromServer);
    result.shipmentToBuyerDate              = Core.utils.hydrate(data.shipmentToBuyerDate, DateSimple.fromServer);
    result.shipmentToBuyerAccountingSumFull = Core.utils.hydrate(data.shipmentToBuyerAccountingSumFull, Sum.fromServer);
    result.tehnoShipmentSumFull             = Core.utils.hydrate(data.tehnoShipmentSumFull, Sum.fromServer);
    result.tehnoSumFull                     = Core.utils.hydrate(data.tehnoSumFull, Sum.fromServer);

    return result;
  }

  get documentTitle(): string {
    return `${this.documentType} №${this.documentNumber} от ${this.documentDate.format()}`;
  }

  /** Наценка реализации к приобретению; null — реализации ещё нет или приобретение без суммы */
  get markup(): Multiplier | null {
    if (this.shipmentToBuyerAccountingSumFull === null || this.accountingSumFull === null || this.accountingSumFull.isZero() === true) {
      return null;
    }
    else {
      return this.shipmentToBuyerAccountingSumFull.divBySum(this.accountingSumFull);
    }
  }

  /** Разница Техно и ЭТП; null — одна из сумм ещё неизвестна */
  get tehnoDifference(): Sum | null {
    if (this.tehnoSumFull === null || this.tehnoShipmentSumFull === null) {
      return null;
    }
    else {
      return this.tehnoSumFull.minus(this.tehnoShipmentSumFull);
    }
  }
}

export default ShipmentReconciliation;
